// Clear stale server feedback only for the field group being edited.
export function clearFieldErrors(element) {
  element.querySelectorAll("[data-field-error]").forEach(error => { error.hidden = true; });
  element.querySelectorAll('[aria-invalid="true"]').forEach(input => { input.setAttribute("aria-invalid", "false"); });
  element.querySelectorAll(".ring-error").forEach(error => { error.classList.remove("ring-1", "ring-error"); });

  const fields = new Set(Array.from(element.querySelectorAll("[name]"), input => input.name.match(/\[([^\]]+)\](?:\[\])?$/)?.[1]));
  const summaries = element.closest("form")?.querySelectorAll("[data-form-errors]") || [];
  summaries.forEach(summary => {
    const messages = Array.from(summary.querySelectorAll("[data-error-attribute]"));
    messages.forEach(message => { if (fields.has(message.dataset.errorAttribute)) message.hidden = true; });
    summary.hidden = messages.every(message => message.hidden);
    summary.classList.toggle("hidden", summary.hidden);
  });
}
